<app-loader [hideSpinner]="isDataLoaded"></app-loader>
<div [ngClass]="{ 'hidden': !isDataLoaded }" class="product-view-container" *ngIf="product">
    <nav class="product-header sticky-top navbar navbar-light bg-light" [ngClass]="{ 'im-dirty': isModified }">
        <span class="navbar-brand">Product View</span>
        <div class="navbar-nav mr-auto"></div>
        <button type="button" class="btn btn-secondary btn-cancel" (click)="cancel()">
            <span>Cancel</span>
        </button>
        <button type="button" class="btn btn-primary btn-save" (click)="save()">
            <span>Save</span>
        </button>
        <button type="button" class="btn btn-danger btn-delete" (click)="delete()">
            <span>Delete</span>
        </button>
        <button *ngIf="product.Active" type="button" class="btn btn-warning btn-deactivate" (click)="deactivate()">
            <span>Deactivate</span>
        </button>
        <button *ngIf="!product.Active" type="button" class="btn btn-primary btn-activate" (click)="activate()">
            <span>Activate</span>
        </button>
        <button mat-icon-button class="btn-close" (click)="back()">
            <mat-icon>close</mat-icon>
        </button>
    </nav>
    <div class="product-container">
        <mat-card>
            <div class="row">
                <div class="col-8">
                    <label>Title</label>
                    <div class="input-group mb-3">
                        <input [(ngModel)]="product.Name" type="text" class="form-control" (input)="dataChanged()">
                    </div>
                    <label>Product Code</label>
                    <div class="input-group mb-3">
                        <input [(ngModel)]="product.Code" type="text" class="form-control" (input)="dataChanged()">
                    </div>
                    <label>Product SKU</label>
                    <div class="input-group mb-3">
                        <input [(ngModel)]="product.SKU" type="text" class="form-control" (input)="dataChanged()">
                    </div>
                    <label>Description</label>
                    <div class="input-group mb-3">
                        <textarea [(ngModel)]="product.Description" class="form-control" rows="5"
                            (input)="dataChanged()"></textarea>
                    </div>
                    <label>Weight</label>
                    <div class="input-group">
                        <input [(ngModel)]="product.Weight" type="text" class="form-control" aria-label="Weight" min="0"
                            max="999999" step="1" (input)="dataChanged()" />
                    </div>
                    <div><em>(Do not use decimal points)</em></div>
                </div>
                <div class="col-4">
                    <div style="margin-bottom: 15px;">
                        <div style="width:300px">
                            <img class="flex-auto img-thumbnail" data-src="{{this.getImageUrl() + 'noimage.png'}}"
                                *ngIf="!product.ImageUrl || product.ImageUrl === '' " />
                            <img class="flex-auto img-thumbnail"
                                data-src="{{product.ImageUrl.startsWith('http') ? product.ImageUrl : this.getImageUrl() + product.ImageUrl}}"
                                *ngIf="product.ImageUrl" />
                        </div>
                    </div>
                    <label for="product-url">Product Image</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">filename</span>
                        </div>
                        <input [(ngModel)]="product.ImageUrl" type="text" class="form-control" id="product-url"
                            (input)="dataChanged()">
                    </div>
                    <div class="mb-3">
                        <a href="javascript: void(0);" (click)="showUploadDialog($event)"
                            class="d-flex align-items-center uploadLink">
                            <mat-icon aria-hidden="false" aria-label="Example home icon" class="mr-1 uploadLink__icon">
                                cloud_upload
                            </mat-icon>
                            <span class="uploadLink__text">Upload new image</span>
                        </a>
                    </div>
                    <div class="form-group mb-3">
                        <label for="ItemType">Item Type</label>
                        <select class="form-control" id="ItemType" [(ngModel)]="product.ItemType"
                            (change)="dataChanged()">
                            <option value="0">Undefined</option>
                            <option value="1">Product</option>
                            <option value="2">Package</option>
                        </select>
                    </div>
                    <!-- <div class="form-group mb-3">
                        <label for="PackageType">Package Type</label>
                        <select class="form-control" id="PackageType" [(ngModel)]="product.PackageType"
                            (change)="dataChanged()">
                            <option value="0">Undefined</option>
                            <option value="LOCAL">Local</option>
                            <option value="HALFSTEP">Half Step</option>
                            <option value="SILVER">Silver</option>
                            <option value="GOLD">Gold</option>
                            <option value="PLATINUM">Platinum</option>
                            <option value="PREMIER">Premier</option>
                            <option value="ELITE">Elite</option>
                            <option value="GLOBAL">Global</option>
                        </select>
                    </div>
                    <div class="form-group mb-3">
                        <label for="PackageType">Entry Type</label>
                        <select class="form-control" id="PackageType" [(ngModel)]="product.EntryType"
                            (change)="dataChanged()">
                            <option value="0">Undefined</option>
                            <option value="LOCAL">Local</option>
                            <option value="PREMIER">Premier</option>
                            <option value="PREMIERPLUS">PremierPlus</option>
                        </select>
                    </div> -->
                    <div class="form-group mb-3">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Category</mat-label>
                            <mat-select [formControl]="categories" multiple (selectionChange)="dataChanged()">
                                <mat-option *ngFor="let item of globals.StaticOptions.Category" [value]="item.id">
                                    {{item.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-card>

        <mat-card *ngIf="product.ItemType == 2">
            <app-bundle-items [productId]="product.Id"></app-bundle-items>
        </mat-card>

        <mat-card>
            <mat-card-header>
                <mat-card-title>Prices Per Origin</mat-card-title>
            </mat-card-header>
            <mat-card-content class="h-100">
                <app-country-pricing-collapsible *ngFor="let price of product.Prices" (refresh)="refresh()"
                    [price]="price" [product]="product">
                </app-country-pricing-collapsible>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-header>
                <mat-card-title>Contents</mat-card-title>
            </mat-card-header>
            <div class="collection-list" *ngIf="product.Content && product.Content.length > 0">
                <div class="collection-box" *ngFor="let item of product.Content">
                    {{item.Data}}
                    <button mat-stroked-button class="collection-delete" (click)="deleteContent(item.Id)">
                        <mat-icon>delete</mat-icon>
                        <span>Delete</span>
                    </button>
                </div>
            </div>
            <div *ngIf="!showAddContents" (click)="showAddContents = true" class="display-flex">
                <div></div>
                <div style="margin-left: auto; order: 2;">
                    <button mat-stroked-button>
                        <mat-icon>add</mat-icon>
                        <span>Add Item</span>
                    </button>
                </div>
            </div>
            <div *ngIf="showAddContents" class="p-3">
                <div class="w-100">
                    <textarea [(ngModel)]="newProductContent.Data" class="form-control" rows="5"></textarea>
                </div>
                <div class="w-100 display-flex" style="padding-top: 10px;">
                    <div></div>
                    <div style="margin-left: auto; order: 2;">
                        <button type="button" class="btn btn-secondary btn-cancel btn-sm" (click)="cancelAddContent()">
                            <span>Cancel</span>
                        </button>
                        <button type="button" class="btn btn-primary btn-save btn-sm" (click)="addContent()">
                            <span>Save</span>
                        </button>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
</div>